<template>
	<div class="text-left">
		<p v-text="params.message" class="small"></p>

		<div v-if="list_of_quizzes.length > 0">
			<b-list-group
				v-for="item in list_of_quizzes"
				:key="item.pkid"
				class="flex-column align-items-start"
			>
				<div class="p-2 quiz_row">
					<div class="row">
						<div class="col-12">
							<span v-if="item.status_taken && item.status_taken == 2" class="small mr-1">
								<i class="fas fa-check fa-2x"></i>
							</span>
							<span
								v-else-if="item.status_taken && item.status_taken == 9"
								class="small mr-1"
							>
								<i class="fas fa-exclamation fa-2x pr-1 text-warning"></i>
							</span>
							<b class="text-success" v-text="item.title"></b>
						</div>
						<div class="col-12 text-right">
							<div
								v-if="item.status_taken && item.status_taken == 2"
								class="text-success small"
							>
								<span><b>Submitted: </b> <i v-text="item.date_taken"></i></span>
								<br />
								<!-- <b-button size="sm" variant="outline-secondary">View results</b-button> -->
							</div>
							<div
								v-else-if="item.status_taken && item.status_taken == 9"
								class="text-warning small"
							>
								<span>In progress: <i v-text="item.date_taken"></i></span>
								<br />
								<button
									type="button"
									class="btn btn-sm btn-outline-warning"
									@click="takeQuiz(item.pkid)"
								>
									continue quiz
								</button>
							</div>
							<div
								v-else-if="item.date_taken !== null"
								class="pointer gold small"
								@click="takeQuiz(item.pkid)"
							>
								Taken: <i v-text="item.date_taken"></i>
							</div>
							<div v-else>
								<button
									type="button"
									class="btn btn-sm btn-outline-primary"
									@click="takeQuiz(item.pkid)"
								>
									take quiz
								</button>
							</div>
						</div>
						<div class="col-12">
							<small v-text="item.description"></small>
						</div>
					</div>
				</div>
			</b-list-group>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	name: 'BioTestingDashboardCard',
	components: {},
	props: {
		params: {
			type: Object,
			default: null,
		},
		userid: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			list_of_quizzes: [],
		};
	},
	mounted() {
		this.questionnaireList();
	},

	computed: {},

	methods: {
		questionnaireList() {
			let _this = this;

			_this.list_of_quizzes = [];

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('user_id', _this.userid);
			params.append('status', 1);

			axios({
				url: _this.$store.state.api_url + 'bio_questionnaire_list',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.list_of_quizzes = response.data.list;
					}
				})
				.catch(function (e) {
					console.log('Error: bio_questionnaire_list:' + e);
				});
		},

		takeQuiz(pkid) {
			this.$router.push('/bioTesting/takeQuiz/' + pkid);
		},
	},

	watch: {},
};
</script>

<style scoped>
.quiz_row {
	border-bottom: 1px solid #ccc;
}
</style>
